export interface MetaOAuthStartResult {
    appId: string;
    configId: string;
    state: string;
}

export interface MetaOAuthCallbackSuccessPayload {
    state: string;
    code: string;
    wabaId: string;
    phoneNumberId?: string;
}

export interface MetaOAuthCallbackErrorPayload {
    state: string;
    error: string;
    errorReason?: string;
    errorDescription?: string;
}

export type MetaOAuthCallbackPayload =
    | MetaOAuthCallbackSuccessPayload
    | MetaOAuthCallbackErrorPayload;

export type MetaOAuthCallbackStatus = 'awaiting_confirmation' | 'connected' | 'cancelled' | 'error';

export interface MetaOAuthCallbackResult {
    status: MetaOAuthCallbackStatus;
    message: string;
}

export type MetaConnectionStatus = 'awaiting_confirmation' | 'connected' | 'pending' | null;

export interface MetaPhoneNumber {
    phoneNumberId: string | null;
    displayPhoneNumber: string | null;
    verifiedName: string | null;
    qualityRating: string;
    registrationStatus: string;
    isActive: boolean;
    lastSyncedAt: string | null;
}

export interface MetaWhatsAppNumberPolicy {
    version: number;
    used: number;
    limit: number | null;
    full: boolean;
    phones: MetaWhatsAppNumberPolicyPhone[];
}

// The approval write returns a decision, not a policy snapshot; reload the policy after it.
export interface MetaWhatsAppPhoneApprovalResult {
    decision: 'APPLIED' | 'REPLAYED';
}

export interface MetaWhatsAppNumberPolicyPhone {
    id: number;
    wabaId: string;
    phoneNumberId: string;
    displayPhoneNumber: string | null;
    registrationStatus: string;
    approvalStatus: string;
    isActive: boolean;
    primaryState: 'OPERATING' | 'META_ACTIVE_NOT_APPROVED' | 'NOT_OPERATING';
    stateExplanation: string;
}

export interface MetaAuditUser {
    id: number;
    name: string;
}

export interface MetaConnectionStatusResult {
    status: MetaConnectionStatus;
    connectionId: string | null;
    wabaId: string | null;
    businessId: string | null;
    displayName: string | null;
    phoneNumbers: MetaPhoneNumber[];
    hasOtherSubscribedApps: boolean;
    systemUserAssigned: boolean;
    webhookSubscribed: boolean;
    migrationRequired?: boolean;
    connectedAt: string | null;
    lastSyncedAt: string | null;
    createdByUserId?: number | null;
    createdBy?: number | null;
    createdByUser?: MetaAuditUser | null;
    disconnectedByUserId?: number | null;
    disconnectedBy?: number | null;
    disconnectedByUser?: MetaAuditUser | null;
    disconnectedAt?: string | null;
    createdAt?: string | null;
}

export type MetaWaba = MetaConnectionStatusResult;
